<video width="100%" height="100%" controls autoplay>
    <source src={{data.videoSrc}} type="video/mp4">
</video>